(() => {
  if (document.documentElement.dataset.rbwNavigationBound) return;
  document.documentElement.dataset.rbwNavigationBound = 'true';
  const header = () => document.getElementById('rbw-site-header');
  const disclosures = () => [...(header()?.querySelectorAll('.mobile-menu, .rbw-catalog, .rbw-localization, .rbw-search') || [])];
  const close = (except) => disclosures().forEach(item => { if (item !== except) item.open = false; });
  const updateMenuPosition = () => {
    const current = header();
    if (!current) return;
    const bar = current.querySelector('.rbw-header');
    const bottom = Math.max(0, Math.min(window.innerHeight - 44, bar.getBoundingClientRect().bottom));
    current.style.setProperty('--rbw-menu-top', bottom + 'px');
    const section = current.closest('.shopify-section');
    if (section) {
      if (disclosures().some(item => item.open)) {
        if (!section.dataset.rbwPreviousZ) section.dataset.rbwPreviousZ = section.style.zIndex || 'auto';
        section.style.zIndex = '1000';
      } else if (section.dataset.rbwPreviousZ) {
        section.style.zIndex = section.dataset.rbwPreviousZ === 'auto' ? '' : section.dataset.rbwPreviousZ;
        delete section.dataset.rbwPreviousZ;
      }
    }
  };
  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
      try {
        const result = await event.promise;
        const count = result?.cart?.totalQuantity ?? result?.detail?.itemCount;
        if (!Number.isInteger(count) || count < 0) return;
        const bag = header()?.querySelector('.rbw-bag');
        const counter = bag?.querySelector('.rbw-bag-count');
        if (!bag || !counter) return;
        counter.textContent = String(count);
        const label = bag.getAttribute('aria-label');
        if (label) bag.setAttribute('aria-label', label.replace(/\(\d+\)/, '(' + count + ')'));
      } catch (error) {
        if (error?.name !== 'AbortError') console.warn('[rbw-bag] Cart update failed:', error);
      }
    });
  }).catch(error => console.warn('[rbw-bag] Cart events unavailable:', error));
  window.addEventListener('scroll', updateMenuPosition, { passive: true });
  window.addEventListener('resize', updateMenuPosition);
  const observer = new ResizeObserver(entries => {
    updateMenuPosition();
    entries.forEach(({ target }) => {
      const height = `${Math.ceil(target.getBoundingClientRect().height)}px`;
      if (target.style.getPropertyValue('--rbw-navigation-height') !== height) target.style.setProperty('--rbw-navigation-height', height);
    });
  });
  const observeHeader = () => { observer.disconnect(); const current = header(); if (current) observer.observe(current); };
  observeHeader();
  window.matchMedia('(max-width:940px)').addEventListener('change', () => {
    const wasOpen = disclosures().some(item => item.open);
    close();
    if (wasOpen) header()?.querySelector('.brand')?.focus({ preventScroll: true });
  });
  document.addEventListener('shopify:section:load', observeHeader);
  document.addEventListener('toggle', event => {
    if (event.target.open && disclosures().includes(event.target)) close(event.target);
    if (disclosures().includes(event.target)) updateMenuPosition();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = disclosures().find(item => item.open);
    if (!open) return;
    close();
    open.querySelector('summary')?.focus();
    event.preventDefault();
  });
  document.addEventListener('focusout', event => {
    const current = header();
    if (current?.contains(event.target) && event.relatedTarget instanceof Element && !current.contains(event.relatedTarget)) close();
  });
  document.addEventListener('pointerdown', event => { if (!header()?.contains(event.target)) close(); });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-rbw-menu-dismiss]')) {
      const open = disclosures().find(item => item.open);
      close();
      open?.querySelector('summary')?.focus({ preventScroll: true });
      return;
    }
    if (header()?.contains(event.target) && event.target.closest('a[href]')) close();
    const link = event.target.closest('[data-rbw-topic]');
    if (!link) return;
    const select = document.querySelector('.rbw-contact-area select[name="contact[subject]"]');
    if (select && select.options.length > 1) select.selectedIndex = 1;
  });
})();

